/**
 * KeyboardHandoffInput — the off-screen text input that `lib/keyboard-handoff`
 * focuses inside a tap, so iOS raises the keyboard before the destination's
 * own search exists (that module has the why). It is a REAL editable input:
 * `display: none`, `visibility: hidden` and `readOnly` all keep the keyboard
 * down, so it hides by size and opacity instead. It carries the same keyboard
 * layout as the serve search (`type="search"`, search return key) so nothing
 * flips when the focus moves over.
 *
 * `CafeteriaKeyboardHandoffBoundary` mounts it ONCE above every cafeteria
 * route. Today (inside the mode layout) and Serve (a sibling outside it) are
 * different route branches, and the bridge has to outlive the navigation
 * between them — a bridge inside either page would unmount mid-handoff and
 * drop the keyboard with it.
 */

import { Outlet } from 'react-router'

import { registerKeyboardHandoffInput } from '@/lib/keyboard-handoff'

export function KeyboardHandoffInput() {
  return (
    <input
      ref={registerKeyboardHandoffInput}
      type="search"
      inputMode="search"
      enterKeyHint="search"
      autoComplete="off"
      autoCapitalize="off"
      autoCorrect="off"
      spellCheck={false}
      tabIndex={-1}
      aria-hidden
      data-keyboard-handoff=""
      className="pointer-events-none fixed left-0 top-0 size-px opacity-0"
      defaultValue=""
    />
  )
}

/** Layout route: the bridge, then whatever cafeteria route is active. */
export function CafeteriaKeyboardHandoffBoundary() {
  return (
    <>
      <KeyboardHandoffInput />
      <Outlet />
    </>
  )
}
